<template>
  <section
    id="FAQPage"
  >
    <div>
      <breadcrumb-mobile
        ref="header"
        @on-change-page="changePage"
      />
    </div>
    <b-card style="background-color: unset !important;" :dir="$functions.currentLangDirection()">

      <v-expansion-panels>
        <v-expansion-panel
          v-for="(item,i) in items"
          :key="i"
        >
          <v-expansion-panel-header>
            {{ $t(item.title) }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <span style="white-space: pre-line">{{ $t(item.desc) }}</span>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </b-card>
  </section>

</template>
<script>
import Vue from 'vue'

import {
  BCard, BCardBody, BButton, BCollapse, BCardHeader, BCardText,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
import router from '@/router'
import Device from '@/models/device'
import DeviceService from '@/services/device.service'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BreadcrumbMobile,
    BCardText,
    BCardHeader,
    BCollapse,
    BCard,
    BCardBody,
    BButton,
  },
  data: () => ({
    items: [{
      title: 'Text-5',
      desc: 'Text-6',
    }, {
      title: 'Text-7',
      desc: 'Text-8',
    }, {
      title: 'Text-9',
      desc: 'Text-10',
    }, {
      title: 'Text-11',
      desc: 'Text-12',
    }, {
      title: 'Text-13',
      desc: 'Text-14',
    }],
    usertype: getUserData().type,
    tab: null,
    selectedItem: -1,
    selectedItem2: -1,
  }),
  computed: {
  },
  created() {

  },
  mounted() {
    this.$refs.header.getTitle('FAQ')
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  methods: {
    changePage(rout) {
      router.replace({ name: 'home' }).catch(err => {})
    },
    addClick() {
      router.push({ name: 'admin-device-add' })
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'model-list' })
    },
  },
}
</script>

<style>
#FAQPage {
  /*background-color: #232633;*/

}
@media (max-width: 768px) {
  #FAQPage{
    margin: -28px;
  }
  #FAQPage .card{
    height: calc( 100vh - 150px);
    top: -53px;
  }

}
@media (min-width: 768px) {
  #FAQPage{
    background-color: #fff !important;
    width: 800px;
    margin: 0 auto;
  }
}
#FAQPage .card-body{
  padding: 0.5rem;
}
#FAQPage .v-expansion-panel-header{
  padding: 10px 8px !important;
  line-height: 1.8rem;
  text-align: left !important;
}
#FAQPage .v-expansion-panel-content__wrap{
  line-height: 1.6rem;
  font-size: 0.9rem;
  background: beige;
  padding-top: 15px;
}
</style>
